import React from "react";
import module from "./Company.module.css";
import { Table, TableBody, TableCell, TableRow } from "@mui/material";
import Footer from "../components/atomic/organisms/Footer";

const Company = () => {
  const Row = ({ children }) => (
    <TableRow
      sx={{ borderBottom: "1px solid #ccc", borderTop: "1px solid #ccc" }}
    >
      {children}
    </TableRow>
  );
  const TitleCell = ({ children }) => (
    <TableCell
      component="th"
      scope="row"
      align="center"
      sx={{ borderRight: "1px solid #ccc" }}
    >
      {children}
    </TableCell>
  );
  const ContentCell = ({ children }) => (
    <TableCell align="center" sx={{ textAlign: "left" }}>
      {children}
    </TableCell>
  );

  const PersonCell = ({ children, isSmall, isTitle }) => (
    <TableCell
      align="left"
      sx={{
        border: "none",
        fontSize: isSmall ? "0.8rem" : "0.9rem",
        padding: isTitle ? "24px 8px 8px 8px" : "8px",
        color: "#333",
      }}
    >
      {children}
    </TableCell>
  );
  const MapFlame = ({ path }) => (
    <iframe
      src={path}
      width="100%"
      height="250px"
      style={{ border: 0 }}
      allowfullscreen=""
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
    ></iframe>
  );
  return (
    <div>
      <div className={module.top}>
        <h1 className={module.title}>会社概要</h1>
      </div>
      <div className={module.contents}>
        <div>
          <Table>
            <TableBody>
              <Row>
                <TitleCell>会社名</TitleCell>
                <ContentCell>ナッシュ株式会社</ContentCell>
              </Row>
              <Row>
                <TitleCell>住所</TitleCell>
                <ContentCell>
                  <div>
                    <div>
                      <span>〒530-0005</span>
                    </div>
                    <div>
                      大阪府大阪市北区中之島3-3-3 中之島三井ビルディング16F
                    </div>
                  </div>
                </ContentCell>
              </Row>
              <Row>
                <TitleCell>設立</TitleCell>
                <ContentCell>2016年06月</ContentCell>
              </Row>
              <Row>
                <TitleCell>役員</TitleCell>
                <ContentCell>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <PersonCell>取締役</PersonCell>
                        <PersonCell isSmall>※執行役員兼務</PersonCell>
                      </TableRow>
                      <TableRow>
                        <PersonCell>代表取締役</PersonCell>
                        <PersonCell>田中 智也 ※</PersonCell>
                      </TableRow>
                      <TableRow>
                        <PersonCell>取締役</PersonCell>
                        <PersonCell>高山 雄史 ※</PersonCell>
                      </TableRow>
                      <TableRow>
                        <PersonCell>社外取締役</PersonCell>
                        <PersonCell>小川 広通</PersonCell>
                      </TableRow>
                      <TableRow>
                        <PersonCell>社外取締役</PersonCell>
                        <PersonCell>伊東 知康</PersonCell>
                      </TableRow>
                      <TableRow>
                        <PersonCell>社外取締役</PersonCell>
                        <PersonCell>大内 智重子</PersonCell>
                      </TableRow>
                      <TableRow>
                        <PersonCell>社外取締役</PersonCell>
                        <PersonCell>松尾 健介</PersonCell>
                      </TableRow>
                      <TableRow>
                        <PersonCell isTitle>監査役</PersonCell>
                        <PersonCell></PersonCell>
                      </TableRow>
                      <TableRow>
                        <PersonCell>常勤監査役</PersonCell>
                        <PersonCell>仙賀 彰</PersonCell>
                      </TableRow>
                      <TableRow>
                        <PersonCell>社外監査役</PersonCell>
                        <PersonCell>津田 佳典</PersonCell>
                      </TableRow>
                      <TableRow>
                        <PersonCell>社外監査役</PersonCell>
                        <PersonCell>藤井 宣行</PersonCell>
                      </TableRow>
                      <TableRow>
                        <PersonCell>社外監査役</PersonCell>
                        <PersonCell>小林 吉信</PersonCell>
                      </TableRow>
                      <TableRow>
                        <PersonCell isTitle>執行役員</PersonCell>
                        <PersonCell></PersonCell>
                      </TableRow>
                      <TableRow>
                        <PersonCell>社長執行役員</PersonCell>
                        <PersonCell>田中 智也</PersonCell>
                      </TableRow>
                      <TableRow>
                        <PersonCell>副社長執行役員</PersonCell>
                        <PersonCell>高山 雄史</PersonCell>
                      </TableRow>
                      <TableRow>
                        <PersonCell>上級執行役員</PersonCell>
                        <PersonCell>藤岡 裕司</PersonCell>
                      </TableRow>
                      <TableRow>
                        <PersonCell>執行役員</PersonCell>
                        <PersonCell>松下 潤</PersonCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </ContentCell>
              </Row>
              <Row>
                <TitleCell>事業内容</TitleCell>
                <ContentCell>
                  <a
                    href="https://nosh.jp/"
                    target="_blank"
                    className={module.noshLink}
                  >
                    {"nosh(ナッシュ)の製造・販売"}
                  </a>
                </ContentCell>
              </Row>
              <Row>
                <TitleCell>事業所</TitleCell>
                <ContentCell>
                  <div>
                    <div className={module.place}>
                      <div>
                        <span>本社</span>
                      </div>
                      <div>
                        <span>
                          〒530-0005 大阪府大阪市北区中之島3-3-3
                          中之島三井ビルディング16F
                        </span>
                      </div>
                      <div>
                        <MapFlame path="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3280.4755225920694!2d135.4914653764744!3d34.69318428361479!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6000e7b3494d1093%3A0xa6e3ab5af6bd554e!2z44OK44OD44K344Ol5qCq5byP5Lya56S-!5e0!3m2!1sja!2sjp!4v1697687403159!5m2!1sja!2sjp"></MapFlame>
                      </div>
                    </div>
                    <div className={module.place}>
                      <div>
                        <span>尼崎工場</span>
                      </div>
                      <div>
                        <span>〒661-0976 兵庫県尼崎市潮江5-7-1</span>
                      </div>
                      <div>
                        <MapFlame path="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13115.285916472287!2d135.422508!3d34.734894!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6000efb9464e0a89%3A0xa6e4b681b82484b3!2z44CSNjYxLTA5NzYg5YW15bqr55yM5bC85bSO5biC5r2u5rGf77yV5LiB55uu77yW4oiS77yX!5e0!3m2!1sja!2sjp!4v1697687772388!5m2!1sja!2sjp"></MapFlame>
                      </div>
                    </div>
                    <div className={module.place}>
                      <div>
                        <span>櫻島物流センター</span>
                      </div>
                      <div>
                        <span>〒554-0032 大阪府大阪市此花区梅町1丁目2番地</span>
                      </div>
                      <div>
                        <MapFlame path="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13127.283880300223!2d135.4209!3d34.659224!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6000e8ef5e98f9a9%3A0xe9bdced5b0711c8f!2z44CSNTU0LTAwMzIg5aSn6Ziq5bqc5aSn6Ziq5biC5q2k6Iqx5Yy65qKF55S677yR5LiB55uu77yR4oiS77yR77yR!5e0!3m2!1sja!2sjp!4v1697687831116!5m2!1sja!2sjp"></MapFlame>
                      </div>
                    </div>
                  </div>
                </ContentCell>
              </Row>
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default Company;
